"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.clearSafe = exports.safe = void 0;
var ramda_1 = require("ramda");
var noop_1 = require("./noop");
/**
 * Безопасный вызов функции, если аргумент отсуствует (null || undefined) вернет void и не вызовет функцию
 */
function safe(fn) {
    return (0, ramda_1.ifElse)((0, ramda_1.complement)(ramda_1.isNil), fn, noop_1.noop);
}
exports.safe = safe;
/**
 * Более безопасный вариант safe проверяет наличие и длину аргумента
 */
function clearSafe(fn) {
    return (0, ramda_1.ifElse)((0, ramda_1.complement)(ramda_1.isEmpty), fn, noop_1.noop);
}
exports.clearSafe = clearSafe;
//# sourceMappingURL=safe.js.map